import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-around" }
const _hoisted_2 = { class: "mt-3 text-[1.5rem] text-white" }

import { ModalLoading, LoadingContainer } from "@/components/atoms"
import { VueSpinner } from "vue3-spinners"
import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  setup(__props) {

let message = ref("Aguarde, estamos reunindo suas informações")

setTimeout(() => {
	message.value = "Verificando as informações..."
}, 10000)

setTimeout(() => {
	message.value = "Validando as alterações..."
}, 20000)

setTimeout(() => {
	message.value = "Só mais um instante, estamos quase lá!"
}, 30000)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LoadingContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalLoading), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(VueSpinner), {
              size: "60",
              color: "#fff"
            }),
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(message)), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})